import type { ActiveWorkflowStage } from '@/types';

/**
 * Backend workflow stage → app route. This app integrates the lane decision into
 * the /analysis results view, so RISK_ASSESSMENT and LANE_DECISION share /analysis.
 */
export const STAGE_ROUTE: Record<ActiveWorkflowStage, string> = {
  RISK_ASSESSMENT: '/analysis',
  LANE_DECISION: '/analysis',
  AI_TRANSLATION: '/translate',
};

/** Returns the route for a stage, or null for an unknown/future stage (caller falls back). */
export function resolveStageRoute(stage: string): string | null {
  return STAGE_ROUTE[stage as ActiveWorkflowStage] ?? null;
}
